








































































































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ExStore } from 'vuex'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import { createNewMedicationInstructionPayload } from '@/api/medicationInstruction/utils'
import { getEnvVar } from '@/utils'
import Form from '@/mixins/form'
import dayjs from 'dayjs'
import { isCordovaEnvironment } from '@/utils/cordova'
import { isCapacitorEnvironment } from '@/utils/capacitor'

@Component({
  components: {
    TextareaInput: () => import('@/components/common/inputs/TextareaInput.vue'),
    VisitDateSelectInputGroup: () => import('./VisitDateSelectInputGroup.vue'),
    InstructionInputGroup: () => import('./InstructionInputGroup.vue'),
    ExcretionInputGroup: () => import('./ExcretionInputGroup.vue'),
    MedicineInputGroup: () => import('./MedicineInputGroup.vue'),
    Doctor2InputGroup: () => import('./Doctor2InputGroup.vue'),
    DoctorInputGroup: () => import('./DoctorInputGroup.vue'),
    CaremanInputGroup: () => import('./CaremanInputGroup.vue'),
    EatingInputGroup: () => import('./EatingInputGroup.vue'),
    MotorInputGroup: () => import('./MotorInputGroup.vue'),
    SleepInputGroup: () => import('./SleepInputGroup.vue')
  }
})
export default class MedicationInstructionForm extends mixins(Form) {
  @Prop(Number) patientId!: number

  $store!: ExStore
  inputs: MedicationInstructionPayload =
    this.currentInstruction || createNewMedicationInstructionPayload()
  creatingNew = this.currentInstructionId === null
  errorMessage = ''

  pendingSave = false
  visitDatePending = false
  nextVisitDayErrorMessage = ''
  refreshingInputs = false

  get loginUser() {
    return this.$store.getters['user/userInfo']
  }

  get currentInstructionId() {
    return this.currentInstruction ? this.currentInstruction.id : null
  }

  get currentInstruction() {
    return this.$store.getters['medicationInstruction/currentInstruction']
  }

  isNextVisitDateGreatorThanOrEqualVisitDate() {
    if (!this.inputs.nextVisitDate) {
      return true
    }

    return (
      dayjs(this.inputs.nextVisitDate).unix() >=
      dayjs(this.inputs.visitDate).unix()
    )
  }

  @Watch('inputs', { deep: true })
  handleFormEdit() {
    if (!this.refreshingInputs) {
      this.$emit('edit')
    }

    this.refreshingInputs = false
  }

  async handleClickSave() {
    if (this.validator.hasAnyError()) {
      this.errorMessage = '入力内容に誤りがあります。'
      return
    }

    if (!this.isNextVisitDateGreatorThanOrEqualVisitDate()) {
      this.errorMessage =
        '次回訪問予定日は訪問日以降の日にちを指定してください。'
      this.nextVisitDayErrorMessage = this.errorMessage
      return
    }

    if (this.visitDatePending) {
      this.errorMessage = '訪問日を確定してください。'
      return
    }

    this.errorMessage = ''
    this.pendingSave = true

    try {
      if (this.creatingNew) {
        await this.$store.dispatch('medicationInstruction/create', {
          patientId: this.patientId,
          payload: this.inputs
        })
      } else {
        await this.$store.dispatch('medicationInstruction/patch', {
          patientId: this.patientId,
          medicationInstructionId: this.currentInstructionId as number,
          payload: this.inputs
        })
      }
      if (this.currentInstruction) {
        this.refreshingInputs = true
        this.inputs = this.currentInstruction
      }

      this.$emit('save')
    } catch (error) {
      console.error(error)
    } finally {
      this.pendingSave = false
    }
  }

  handleClickCreateNew() {
    this.$store.commit('medicationInstruction/setCurrentInstruction', null)
    this.refreshingInputs = true
    this.inputs = createNewMedicationInstructionPayload()
    this.creatingNew = true
    this.errorMessage = ''
    this.$emit('reset')
  }

  async handleClickDoPrev() {
    if (!this.creatingNew) {
      return
    }

    await this.$store.dispatch('medicationInstruction/fetchLatest', {
      patientId: this.patientId
    })

    if (this.currentInstruction) {
      this.inputs = this.currentInstruction
      this.errorMessage = ''
    } else {
      this.errorMessage = '前回のデータはありませんでした。'
    }
  }

  async downloadCsv() {
    if (isCordovaEnvironment() || isCapacitorEnvironment()) {
      this.$postMessage.openFileDownload({
        isPatient: false,
        isRelative: this.loginUser.isPatientRelative,
        type: 'md',
        patientId: this.patientId,
        fileId: 0,
        fileName: 'medication_instruction.csv'
      })
      return
    }
    const res = await this.$api.medicationInstruction.fetchFile({
      patientId: this.patientId
    })
    const url = window.URL.createObjectURL(res)
    const a = document.createElement('a')
    a.style.opacity = '0'
    document.body.appendChild(a)
    a.download = 'medication_instruction.csv'
    a.href = url
    a.click()
    a.remove()
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 100)
  }
}
